import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';

function ResponsiveNavbar() {
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      bg="dark"
      variant="dark"
      className="fixed-top"
    >
      <Container id="header" class="fixed-top ">
        <Navbar.Brand href="https://softskart.com">
          <strong>SOFTSKART</strong>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              class="nav-link scrollto active"
              href="https://softskart.com"
            >
              Home
            </Nav.Link>
            <Nav.Link
              class="nav-link scrollto"
              href="https://softskart.com/#about"
            >
              About
            </Nav.Link>
            <Nav.Link
              class="nav-link scrollto"
              href="https://softskart.com/#services"
            >
              Services
            </Nav.Link>

            <Nav.Link
              class="nav-link scrollto"
              href="https://softskart.com/#store"
            >
              Store
            </Nav.Link>

            <Nav.Link
              class="nav-link scrollto"
              href="https://softskart.com/#faq"
            >
              FAQ
            </Nav.Link>

            <Nav.Link
              class="nav-link scrollto"
              href="https://softskart.com/#contact"
            >
              Contact
            </Nav.Link>

            {/* <Nav.Link class="nav-link scrollto" href="#team">
              Team
            </Nav.Link> */}

            {/* <NavDropdown title="More" id="collapsible-nav-dropdown">
              <section style={{ backgroundColor: 'black' }}>
                <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2">
                  Terms of Service
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3">
                  Something
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.4">
                  Privacy Policy
                </NavDropdown.Item>
              </section>
            </NavDropdown> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default ResponsiveNavbar;
